import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

import BaseController from '../controllers/BaseController';

interface ReportGenerateResponse {
  uri: string;
}

class ReportService {
  owner: BaseController;

  patientId: string | number;

  nrSequencia!: string | number;

  endpointLista!: string;

  parametrosLista!: Record<string, Value>;

  constructor(owner: BaseController) {
    this.owner = owner;
    this.patientId = owner.context.get('patientId') as string | number;

    if (!this.patientId) {
      this.patientId = owner.getHistoryRouteParam<string>('patientId');
    }
  }

  openInNewWindow(url: string): void {
    const win = window.open(url, '_blank');
    win && win.focus();
  }

  async gerarRelatorio(parametrosRelatorio: Record<string, Value>): Promise<string> {
    const body = {
      parameters: parametrosRelatorio,
    };

    const requestParams = { patientId: this.patientId };

    return HttpService.post<ReportGenerateResponse>(APPLICATION_ENDPOINTS.POST_REPORT_CONTENT, requestParams, { body }).then<string>(response => {
      return resolvePath(`${APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: response.body?.uri })
    });
  }
}

export default ReportService;
